import { Box, FormLabel, Icon, IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React, { FC, Fragment, useEffect, useState } from 'react';
import { getImage, ImageSize } from '@shared/utils/imageFormat';
import { MediaPicker } from '@/components/media-picker';

interface IProps {
  value: string;
  onChange: (value: string) => void;
  label: string;
  conferenceId: string;
}

const useStyles = (theme) => ({
  root: {
    display: 'block !important',
    width: '164px !important',
    height: '96px !important',
    padding: `${theme.spacing(1)} !important`,
    borderColor: `${theme.palette.grey[200]} !important`,
    border: '1px solid  #eeeeee!important',
    marginBottom: `${theme.spacing(2)} !important`,
  },  
  image: {
    display: 'flex !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    width: '100% !important',
    height: '100% !important',
    backgroundColor: `${theme.palette.grey[300]} !important`,
    backgroundSize: 'contain !important',
    backgroundRepeat: 'no-repeat !important',
    backgroundPosition: 'center !important',
  },
});

export const MediaPlaceholder: FC<IProps> = ({
  value,
  onChange,
  label,
  conferenceId,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const [isOpen, setIsOpen] = useState(false);
  const [image, setImage] = useState(value);

  const openDialog = () => {
    setIsOpen(true);
  };

  const onSelectImage = (source_id: string) => {
    onChange(source_id);
    setImage(source_id);
    setIsOpen(false);
  };

  const onRemoveImage = () => {
    onChange(undefined);
    setImage(undefined);
  };

  useEffect(() => {
    setImage(value);
  }, [value]);

  return (
    <Fragment>
      <FormLabel>{label}</FormLabel>
      <Box sx={classes.root}>
        <Box
          sx={classes.image}
          style={{
            ...(image && {
              backgroundImage: `url('${getImage(
                image,
                ImageSize.Medium,
                conferenceId
              )}')`,
            }),
          }}
        >
          {image ? (
            <IconButton size="small" type="button" color="primary" onClick={onRemoveImage}>
              <Icon>delete</Icon>
            </IconButton>
          ) : (
            <IconButton onClick={openDialog}>
              <Icon>add_a_photo</Icon>
            </IconButton>
          )}
        </Box>
      </Box>
      <MediaPicker
        open={isOpen}
        onClose={onSelectImage}
        conferenceId={conferenceId}
      />
    </Fragment>
  );
};
